<template>
    <DetailInventaire/>
</template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import DetailInventaire from "@/components/GesCom/Inventaire/DetailInventaire.vue";

    export default defineComponent({
      name: "DetailInventairePage",
      components: {
        DetailInventaire,
      },
    });
  </script>